<svelte:options accessors={true}/>
<script>
    import HRImport from './../components/HR/HRImport.svelte';
	import JobRoles from './../components/HR/JobRoles.svelte';
    import { onMount } from 'svelte';
    import ReportsService from "../services/reports.service";
    import AuthService from '../services/auth.service.js';
    import Loader from "../components/Loader.svelte";
    import EditableCell from "../components/EditableCell.svelte";
    import HRService from '../services/hr.service.js';
    import ExportService from '../services/export.service'
    //Sorting and pagination
    import EntriesSelector from './../components/sorting/EntriesSelector.svelte';
    import Search from './../components/sorting/Search.svelte';
    import Pagination from './../components/sorting/Pagination.svelte';
    import TalentTrackingService from '../services/talentTracking.service';
    import OrganizationsListModal from '../components/OrganizationsListModal.svelte';

    let page, loading = false, reportData,
        currentCandidate = {}, candidateToChange = {},
        currentPage = 0, search = "", sortBy = "id",
        order = true, totalElements = 0,
        candidateToDelete, candidatesTab="one";
    let filters = {
        all_portcos: true,
        min_days: 0,
        max_days: 1000,
        role: 'All',
        department: 'All',
        employment_status: 'All',
        interview_availability_status: 'All'
    }
    let candidateStatus = {
        action: '',
        candidate_id: '',
        organization_id: '',
        date: '',
        status: 0
    }
    let errorMessage = {
        show: false,
        text: ''
    }

    let temporalCandidate = {};

    export let user, params, loadingExport = false, talentTrackingFilters = 0, entries = 100;

    //Catch when a value change
    $: loadData(params, search, entries, currentPage, order, sortBy, entries);

    let headers = [
        {title: 'Original Portco', key: 'organization_name', customClass : '', editable: false, type: 'text', format: 7, selectOptionsKey: '', width: 150, exportWidth: 25 },
        {title: 'Status Interview Availability', key: 'status', customClass : '', editable: false, type: 'text', format: 7, selectOptionsKey: '', width: 150, exportWidth: 18 },
        {title: 'Name', key: 'name', customClass : '', editable: true, type: 'text', format: 7, selectOptionsKey: '', width: 140, exportWidth: 30 },
        {title: 'Email', key: 'email', customClass : '', editable: true, type: 'text', format: 7, selectOptionsKey: '', width: 100, exportWidth: 30 },
        {title: 'Current Location', key: 'current_location', customClass : '', editable: true, type: 'text', format: 7, selectOptionsKey: '', width: 80, exportWidth: 20 },
        {title: 'Current State', key: 'current_location_state', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'locationStates', width: 80, exportWidth: 20 },
        {title: 'Phone Number', key: 'phone_number', customClass : '', editable: true, type: 'text', format: 9, selectOptionsKey: '', width: 140, exportWidth: 15 },
        {title: 'Employment Status', key: 'employeement_status', customClass : '', editable: true, type: 'select', selectOptionsKey: 'statuses', format: 7, width: 200, exportWidth: 40  },
        {title: 'Linkedin Profile Link', key: 'linkedin', customClass : '', editable: true, type: 'text', format: 7, selectOptionsKey: '', width: 250, exportWidth: 40},
        {title: 'Spi Score', key: 'spi_score', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'spis', width: 90, exportWidth: 10 },
        {title: 'Department', key: 'department', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'departments', width: 80, exportWidth: 12 },
        {title: 'Role Interviewed For', key: 'role', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'jobTTRoles', isCategorizedSelect: true, width: 280, exportWidth: 40 },
        {title: 'Industry Experience', key: 'industry_experience', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'experiences', width: 240, exportWidth: 32 },
        {title: 'Other Experience', key: 'other_experience', customClass : '', editable: true, type: 'text', format: 7, selectOptionsKey: '', width: 240, exportWidth: 32 },
        {title: 'Reason Not Hired', key: 'reason_not_hired', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'reasonNotHired', width: 150, exportWidth: 20  },
        {title: 'Other Reason', key: 'reason_not_hired_note', customClass : '', editable: true, type: 'text', format: 7, selectOptionsKey: '', width: 150, exportWidth: 20  },
        {title: 'Recruiting Firm', key: 'recruiting_firm', customClass : '', editable: true, type: 'select', format: 7, selectOptionsKey: 'recruitingFirms', width: 140, exportWidth: 25  },
        {title: 'External Recruiting Firm', key: 'recruiting_cost', customClass : '', editable: true, type: 'text', format: 7, width: 120, exportWidth: 20  },
        {title: 'Employment Status Last Update', key: 'updated_date', customClass : '', editable: false, type: 'text', format: 7, width: 150, exportWidth: 25  },
        {title: 'Created Date', key: 'created_date', customClass : '', editable: false, type: 'text', format: 7, width: 90, exportWidth: 15  },
        // {title: 'Hired', key: 'hired', customClass : '', editable: true, type: 'text', format: 7, width: 140, exportWidth: 22  },
        {title: 'CV URL', key: 'cv', customClass : '', editable: true, type: 'text', format: 7, width: 240, exportWidth: 40  },
        {title: 'Days From Last Interview', key: 'days', customClass : 'text-center', editable: false, type: 'text', format: 7, width: 120, exportWidth: 23  }
    ];

    const STATUS_COLORS = ['style-green', 'style-yellow', 'style-grey'];
    const STATUS_TYPES = ['Available', 'Interview Scheduled', 'Hired'];
    const MAX_INTERVIEWS_PER_COMPANY = 2;
    onMount(() => {
        loadData();
    });

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        const url = getReportUrl();
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        if (reportData && reportData.totalElements) totalElements = reportData.totalElements;

        loading = false;

        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 500);
    }

    function getReportUrl(isExport = false) {
        const urlOrg = filters.all_portcos ? '0' : params.org;
        const paginationData = isExport ? `${currentPage}/${sortBy}/${order}/${entries}` : `0/id/true/100000`;
        let url = '/org/' + urlOrg + '/talent_tracking_candidates/' + paginationData + getSearch();
        let filtersUrl = `/filters/days/${filters.min_days}/${filters.max_days}/${filters.role}`;
        filtersUrl += `/${filters.department}/${filters.employment_status}/${filters.interview_availability_status}`;
        url += filtersUrl;
        return url;
    }

    export const exportToExcel = async () => {
        loadingExport = true;

        try {
            const url = getReportUrl(true);
            const candidatesReport = (await ReportsService.load(url)).data;
            const fileName =  'Talent-Tracking';

            if (!candidatesReport && !candidatesReport.totalElements) {
                alert('Nothing to export');
            } else {
                await ExportService.downloadCandidates(
                    candidatesReport.candidates,
                    headers,
                    fileName,
                );
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            loadingExport = false;
        }

    };

    const isBlur = function (value) {
        return value === '-----';
    }

    // get random string to use in the blur fields to make it look dynamic
    const getRandomStringBlur = function () {
        const AVAILABLE_STRINGS = [
            '----- -- ---- -----',
            '-------------------------------',
            '-----------------',
            '------ ------- ----- ------',
            '--- ----- ----------'
        ];

        return AVAILABLE_STRINGS.sort(() => Math.random() - 0.5)[0]; // Get random string from array
    }

    const getLockedCandidateMessage = function (remainingDays = 14, statusOrg) {
        return `This candidate is currently beign interview by ${statusOrg}. If the process doesn't continue in ${remainingDays} days, he/she will be unlocked`;
    }

    function getSearch(){
        return (search)? "/" + search : '/-----';
    }

    export const onSearch = function(searchText){
        search = searchText;
    }

    let onSaveCandidate = async function() {
        errorMessage.show = false;
        try {
            const response = await TalentTrackingService.createCandidate(currentCandidate);
            if (response.data.ok) {
                loadData();
                jQuery('#addCandidate').modal('hide');
                cleanCandidate();
            } else {
                errorMessage.show = true;
                errorMessage.text = response.data.error;
            }
        } catch (e) {
            errorMessage.text = e.message;
        }
    }

    function cleanCandidate() {
        currentCandidate = {
            id: '',
            organization_id: params.org,
            name: '',
            email: '',
            phone_number: '',
            spi_score: '',
            role: '',
            current_location: '',
            current_location_state: '',
            industry_experience: '',
            reason_not_hired: '',
            reason_not_note: '',
            recruiting_firm: '',
            recruiting_cost:'',
            candidates_amount: 1
        };
    }

    export const addRow = function(){
        cleanCandidate();
        jQuery('#addCandidate').modal('show');
    }

    export const openFiltersModal = function(){
        cleanCandidate();
        jQuery('#candidateFiltersModal').modal('show');
    }

    async function updateCandidateData(candidateIndex, field, candidate){
        if(jQuery('.hr-pasting').length > 0){
            //Avoid save all the string pasted on the selected cell
            return false;
        }

        try {
            if (candidateIndex) reportData.candidates[candidateIndex].duplicatedField = null;
            const response = await TalentTrackingService.updateCandidate(candidate);
            if (candidateIndex && response.data.error === 'duplicated candidate') reportData.candidates[candidateIndex].duplicatedField = field;
            if (!candidateIndex) jQuery('#updateCandidateOrgModal').modal('hide');
        } catch (e) {
            console.log('Error', e);
        }
    }

    export function selectEntries(entriesSelected){
        currentPage = 0;
        entries = entriesSelected;
    }

    function sort(key){
        //If it's a different column, set asc bt default. If not, set the opposite (asc = desc, desc = asc)
        order = (sortBy == key)? !order : true;
        sortBy = key;
    }

    let openOrganizationsList = function(){
        jQuery('#organizationsListModal').modal('show');
    }

    function openDeleteCandidateModal(candidateId){
        candidateToDelete = candidateId;
        jQuery('#deleteCandidateConfirmation').modal('show');
    }

    async function deleteCandidate(){
        try {
            await TalentTrackingService.delete(candidateToDelete);
            jQuery('#deleteCandidateConfirmation').modal('hide');
            loadData();
        } catch (e) {
            console.log('Error', e);
        }
    }

    //Import
    export const openImportModal = function(){
        jQuery('#importModal').modal('show');
    }

    let onImported = async function(){
        jQuery('#importModal').modal('hide');
        await loadData();
    }

    function applyFilters() {
        talentTrackingFilters = 0;
        const DEFAULT_FILTERS = {
            all_portcos: true,
            min_days: 0,
            max_days: 1000,
            role: 'All',
            department: 'All',
            employment_status: 'All',
            interview_availability_status: 'All'
        }
        Object.keys(filters).map(field => {
            if (filters[field] !== DEFAULT_FILTERS[field]) talentTrackingFilters++;
        });

        jQuery('#candidateFiltersModal').modal('hide');
        loadData();
    }

    function candidateAction(candidate, action) {
        jQuery('#changeStatusModal').modal('show');
        let orgId = 0;
        if (AuthService.userOrganizations.length > 0) orgId = AuthService.userOrganizations[0].id;
        let status = 0;
        if (action === 'interview') status = 1;
        else if (action === 'hire') status = 2;

        let exceededOrg = null;
        if (candidate.status_interview_previous_company) {
            let previousOrgData = candidate.status_interview_previous_company.split('-');
            let previousOrg = parseInt(previousOrgData[0]);
            let orgInterviews = parseInt(previousOrgData[1]);
            if (orgInterviews === MAX_INTERVIEWS_PER_COMPANY) exceededOrg = previousOrg;
        }

        candidateStatus = {
            action,
            candidate_id: candidate.id,
            date: '',
            organization_id: orgId,
            status,
            exceeded_org: exceededOrg
        }
    }

    function hasOrganizationAccess(candidate) {
        const orgId = candidate.status_by ? candidate.status_by : candidate.organization_id;
        return AuthService.userOrganizations.find(org => org.id === orgId) ? true : false;
    }

    async function updateCandidateStatus() {
        try {
            await TalentTrackingService.updateStatus(candidateStatus);
            jQuery('#changeStatusModal').modal('hide');
            loadData();
        } catch (e) {
            console.log('Error', e);
        }
    }

    function isDuplicatedField(candidate, field) {
        return candidate.duplicatedField && candidate.duplicatedField === field;
    }

    export function clearFilters() {
        filters = {
            all_portcos: true,
            min_days: 0,
            max_days: 1000,
            role: 'All',
            department: 'All',
            employment_status: 'All',
            interview_availability_status: 'All'
        }
        talentTrackingFilters = 0;
        loadData();
        jQuery('#candidateFiltersModal').modal('hide');
    }

    function updateCandidateOrg(candidate) {
        temporalCandidate = candidate;
        jQuery('#updateCandidateOrgModal').modal('show');
    }
</script>

<!-- Filters -->
<div class="modal fade" id="candidateFiltersModal" tabindex="-1" role="dialog" aria-labelledby="candidateFiltersModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    Filters
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="font-weight" for="candidate-req_id">Days after interviewing</label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="candidate-req_id">Min</label>
                                            <input  bind:value={filters.min_days} type="number" class="form-control" min="0" name="candidate-days-min" placeholder="0">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="candidate-req_id">Max</label>
                                            <input  bind:value={filters.max_days} type="number" class="form-control" name="candidate-days-max" placeholder="365">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="candidate-req_id">Industry Role</label>
                                            {#if reportData}
                                                <select bind:value={filters.role} class="form-control">
                                                    <option value='All'>All</option>
                                                    {#each reportData.options.jobTTRoles as role}
                                                        {#if role.option.indexOf('*') === 0}
                                                            <option value='' disabled="disabled">{role.option.replace('*', '')}</option>
                                                        {:else if role.option.indexOf('-') === 0}
                                                            <option value={role.value}>{@html role.option.replace('-', "•  ")}</option>
                                                        {:else}
                                                            <option value={role.value}>{role.option}</option>
                                                        {/if}
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="candidate-req_id">Employment Status</label>
                                            {#if reportData}
                                                <select bind:value={filters.employment_status} class="form-control">
                                                    <option value='All'>All</option>
                                                    {#each reportData.options.statuses as status}
                                                        <option value={status.value}>{status.option}</option>
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="candidate-req_id">Department</label>
                                            {#if reportData}
                                                <select bind:value={filters.department} class="form-control">
                                                    <option value='All'>All</option>
                                                    {#each reportData.options.departments as department}
                                                        <option value={department.value}>{department.option}</option>
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="candidate-req_id">Status Interview Availability</label>
                                            {#if reportData}
                                                <select bind:value={filters.interview_availability_status} class="form-control">
                                                    <option value='All'>All</option>
                                                    {#each reportData.options.inverviewAvailabilitiesStatuses as option}
                                                        <option value={option.value}>{option.option}</option>
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" on:click={clearFilters}>Clear Filters</button>
                    <button type="button" class="btn btn-success" on:click={applyFilters}>Apply</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Add/edit candidate and add/edit tracking stages-->
<div class="modal fade" id="addCandidate" tabindex="-1" role="dialog" aria-labelledby="addCandidate" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    Add Candidate
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form on:submit|preventDefault={onSaveCandidate}>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- <div class="form-group">
                                <label class="radio-inline mr-5">
                                    <input type="radio" class="mr-2" name="candidates_one" bind:group={candidatesTab} value="one">One
                                </label>
                                <label class="radio-inline">
                                    <input type="radio" class="mr-2" name="candidates_multiple" bind:group={candidatesTab} value="multiple">Multiple Entries
                                </label>
                            </div> -->
                            <!-- {#if candidatesTab == "one"} -->
                                {#if reportData}
                                    {#if errorMessage.show}
                                        <div id="candidate-modal-error" class="alert alert-danger" role="alert">
                                            {errorMessage.text}
                                            <button type="button" class="close" on:click={ () => errorMessage.show = false}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    {/if}
                                    <div class="form-group">
                                        {#if AuthService.userOrganizations.length > 0 }
                                            <label for="candidate-status-organization">Organization</label>
                                            <select bind:value={currentCandidate.organization_id} class="form-control">
                                                {#each AuthService.userOrganizations as org}
                                                    <option value={org.id}>{org.name}</option>
                                                {/each}
                                            </select>
                                        {/if}
                                    </div>
                                    <div class="form-group">
                                        <label for="candidate-name">*Name</label>
                                        <input  bind:value={currentCandidate.name} type="text" class="form-control" name="candidate-name" id="candidate-name" placeholder="John Doe">
                                    </div>
                                    <div class="form-group">
                                        <label for="candidate-email">*Email</label>
                                        <input  bind:value={currentCandidate.email} type="text" class="form-control" name="candidate-email" id="candidate-email" placeholder="example@mail.com">
                                    </div>
                                    <div class="form-group">
                                        <label for="nameInput">*Phone Number</label>
                                        <input required bind:value={currentCandidate.phone_number} type="text" class="form-control" name="candidate-phone_number" id="candidate-phone_number" placeholder="Phone number">
                                    </div>
                                {/if}
                            <!-- {:else}
                                <div class="form-group">
                                    <label for="candidate-req_id">* Number of candidates to add</label>
                                    <input  bind:value={currentCandidate.candidates_amount} type="number" min="1" max="30" class="form-control" name="candidate-amount" id="candidate-amount" placeholder="10">
                                </div>
                            {/if} -->
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanCandidate}>Close</button>

                    <button type="submit" class="btn btn-success">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete candidate -->
<div class="modal fade" id="deleteCandidateConfirmation" tabindex="-1" role="dialog" aria-labelledby="deleteCandidateConfirmation" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteCandidateLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete this candidate?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => deleteCandidate()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Change Status -->
<div class="modal fade" id="changeStatusModal" tabindex="-1" role="dialog" aria-labelledby="changeStatusModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteCandidateLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> Warning
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to change this candidate's status to <b>{STATUS_TYPES[candidateStatus.status]}?</b></p>

                {#if candidateStatus.action === 'interview'}
                    <label for="candidate-status-organization">Organization</label>
                    {#if AuthService.userOrganizations.length > 0 }
                        <select bind:value={candidateStatus.organization_id} class="form-control">
                            {#each AuthService.userOrganizations as org}
                                <option value={org.id}>{org.name}</option>
                            {/each}
                        </select>
                    {:else}
                        <p>{AuthService.userOrganizations[0].name}</p>
                    {/if}

                    {#if candidateStatus.exceeded_org === candidateStatus.organization_id}
                         <small class="text-danger">This company exceeded the interviews for this candidate</small>
                    {/if}
                {/if}

                {#if candidateStatus.action === 'hire'}
                    <div class="talent-action mt-2 form-group">
                        <label for="candidate-status-date">Hire Date</label>
                        <input  bind:value={candidateStatus.date} type="date" class="form-control">
                    </div>
                {/if}

            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " disabled={candidateStatus.exceeded_org === candidateStatus.organization_id} on:click={() => updateCandidateStatus()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Update Organization -->
<div class="modal fade" id="updateCandidateOrgModal" tabindex="-1" role="dialog" aria-labelledby="deleteCandidateConfirmation" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteCandidateLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to change this candidate's original portco?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => updateCandidateData(null, null, temporalCandidate)} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader></Loader>
{:else}
    {#if AuthService.canShow('talent_tracking_tab') || AuthService.can('MAKE_EXTERNAL_TALENT_TRACKING_CHANGES') }
        <HRImport params={params} module="talent_tracking" showGuide='true' guide_name='Talent+Tracking+Data+Import+User+Guide' on:imported={onImported}></HRImport>
    {/if}
    <OrganizationsListModal organizations={AuthService.userOrganizations}></OrganizationsListModal>
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>

    <div class="table-wrapper hr-report talent-tracking-report">
        <table class="table table-sm container-fluid table-weekly selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    {#if AuthService.canShow('talent_tracking') || AuthService.can('MAKE_EXTERNAL_TALENT_TRACKING_CHANGES')}
                        <th class="delete-cell" rowspan="2"></th>
                    {/if}
                    {#each headers as header, headerIndex}
                        <!-- <th rowspan="2" style="min-width:{header.width}px" class="col-subheader {header.customClass}">{header.title}</th> -->
                        {#if header.editable}
                            <th
                              rowspan="2"
                              style="min-width: {header.width}px"
                              class="col-subheader {header.customClass} {headerIndex > 4 ? 'notFixed' : '' }">
                                <span class="pointer" on:click={() => sort(header.key)}>
                                    {header.title}
                                    <i class="fa fa-sort-{(sortBy == header.key && !order) ? 'desc' : 'asc' } {(sortBy == header.key) ? 'text-primary' : '' }"></i>
                                </span>
                            </th>
                        {:else}
                            <th style="min-width: {header.width}px" class="col-subheader {header.customClass} {headerIndex > 4 ? 'notFixed' : '' }">
                                {@html header.title}
                                {#if header.key === 'organization_name'}
                                <i
                                    class="fa fa-info-circle ml-2 mr-1 vertical-middle pointer"
                                    on:click={ openOrganizationsList }
                                ></i>
                            {/if}
                            </th>
                        {/if}
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each reportData.candidates as candidate, candidateIndex}
                    <tr>
                        {#if AuthService.canShow('talent_tracking') || AuthService.can('MAKE_EXTERNAL_TALENT_TRACKING_CHANGES')}
                             <th class="delete-cell">
                                 <i
                                     class="fa fa-trash text-danger pointer"
                                     on:click={() => openDeleteCandidateModal (candidate.id)}
                                 ></i>
                             </th>
                        {/if}
                        {#each headers as header, column}
                            {#if header.editable && hasOrganizationAccess(candidate)}
                                <td
                                  class="hr-cell-border {column > 4 ? 'notFixed' : 'talent-readonly' } hr-cell-border {isDuplicatedField(candidate, header.key) ? 'duplicated' : ''}" data-toggle="tooltip" data-placement="top" title="{ isDuplicatedField(candidate, header.key) ? `This ${header.title.toLowerCase()} is associated with another candidate` : ''}">
                                    <EditableCell
                                        id="t1-{candidateIndex}-{column}"
                                        on:change={(e) => updateCandidateData(candidateIndex,  header.key, candidate)}
                                        bind:value={candidate[header.key]}
                                        type={header.type}
                                        hrData="{ {candidate: candidate.id, key: header.key, model: 'candidates', format: header.format} }"
                                        selectOptions={(header.type == "select" && reportData.options[header.selectOptionsKey]) ? reportData.options[header.selectOptionsKey] : []}
                                        isCategorizedSelect={header.isCategorizedSelect}
                                        customClass="hr-cell" format={header.format}></EditableCell>
                                </td>
                            {:else}
                                <td class="hr-cell-border talent-readonly {column > 4 ? 'notFixed ' : 'readOnly' } {candidate.blur && isBlur(candidate[header.key]) ? 'blur text-truncate' : ''}"
                                    data-toggle="tooltip" data-placement="top"
                                    title="{candidate.blur && isBlur(candidate[header.key]) ? getLockedCandidateMessage(candidate.remainingDays, candidate.status_org) : ''}"
                                >
                                    {#if header.key === 'status'}
                                        {#if candidate.status === 0 || hasOrganizationAccess(candidate)}
                                            <div class="dropdown">
                                                <button class="btn {STATUS_COLORS[candidate.status]} btn-status dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                                    {STATUS_TYPES[candidate.status]}
                                                </button>
                                                <div class="dropdown-menu">
                                                    {#if candidate.status === 0}
                                                        <li class="dropdown-item" on:click="{() => candidateAction(candidate, 'interview')}">Schedule Interview</li>
                                                    {:else if candidate.status === 1}
                                                        <li class="dropdown-item" on:click="{() => candidateAction(candidate, 'drop')}">Declined</li>
                                                        <li class="dropdown-item" on:click="{() => candidateAction(candidate, 'hire')}">Hire</li>
                                                    {:else}
                                                        <li class="dropdown-item" on:click="{() => candidateAction(candidate, 'make_available')}">Make Available</li>
                                                    {/if}
                                                </div>
                                            </div>
                                        {:else}
                                            <div class="talent-readonly readOnly talent-status {STATUS_COLORS[candidate.status]}">
                                                {STATUS_TYPES[candidate.status]}
                                            </div>
                                        {/if}
                                    {:else if header.key === 'organization_name' && (AuthService.canShow('talent_tracking') || AuthService.can('MAKE_EXTERNAL_TALENT_TRACKING_CHANGES'))}
                                        <select class="hr-cell hr-select" bind:value={candidate.organization_id}  on:change="{() => updateCandidateOrg(candidate)}">
                                            {#each AuthService.userOrganizations as org}
                                                <option value={org.id}>{org.name}</option>
                                            {/each}
                                        </select>
                                        <span class="selectedOrgName" style="display:none">{candidate.organization_name}</span>
                                    {:else}
                                        {candidate.blur && isBlur(candidate[header.key]) ? getRandomStringBlur() : candidate[header.key] || ''}
                                    {/if}
                                </td>
                            {/if}
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    <Pagination {currentPage} {entries}  {totalElements} on:change={(e) => currentPage = e.detail.page} />
{/if}

<style>
    .disabled-td{
        background-color: lightgray !important;
        cursor: not-allowed;
        word-spacing: -2px;
    }

    .font-weight {
        font-weight: 400;
    }

    .btn-status {
        padding: 5px !important;
        font-size: 12px;
        width: 100%;
        text-align: left;
    }

    .dropdown-item {
        font-size: 12px;
    }

    .talent-readonly {
        color: #000 !important;
        text-align: left;
    }

    .talent-bg-primary {
        background: #00529f!important;
    }

    .talent-bg-success {
        background-color: #28a745;
    }

    .talent-bg-secondary {
        background-color: #6c757d;
    }

    .talent-status {
        padding: 5px !important;
    }

    .duplicated {
        border: solid red 2px !important;
    }

    #candidate-modal-error {
        padding: 0.74rem 1rem;
    }
</style>
